export default __webpack_public_path__ + "static/media/2025_orien.cf9e1122.pdf";